import { render, staticRenderFns } from "./classAdministrator.vue?vue&type=template&id=4d53de78"
import script from "./classAdministrator.vue?vue&type=script&lang=js"
export * from "./classAdministrator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports